module.exports = __webpack_public_path__ + "media/images/candle-0ae0d920692bcc918455c26595a72c29.gif";